import React from "react";
import moment from "moment";
import "moment/locale/ko";
import PretendardText from "../../../component/atoms/text/pretendardText";

const HomeCustomTooltip = ({ active, payload }) => {
  // 스타일 객체
  const circleStyle = {
    width: "18px",
    height: "18px",
    borderRadius: "50%",
  };

  if (active && payload && payload.length) {
    return (
      <div
        style={{
          width: "fit-content",
          height: "fit-content",
          backgroundColor: "#313233",
          padding: "10px 12px",
          border: "1px solid rgba(255, 255, 255, 0.12)",
          boxShadow: "1px 1px 4px 0px rgba(0, 0, 0, 0.12)",
        }}
      >
        <p
          style={{
            fontFamily: "Pretendard",
            fontWeight: 600,
            fontSize: "13px",
            lineHeight: "22.75px",
            color: "#f3f3f3",
            marginBottom: "8px",
          }}
        >
          {moment(payload[0].payload.date).format("YYYY-MM-DD")}(
          {moment(payload[0].payload.date).local().format("ddd")})
        </p>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "5px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
          >
            <span
              style={{
                ...circleStyle,
                backgroundColor: "#b658ff",
              }}
            />
            <PretendardText
              style={{
                fontWeight: 600,
                fontSize: "14px",
                lineHeight: "22.75px",
                color: "#aaa",
              }}
            >
              {`${payload[0].value.toLocaleString()}명`}
            </PretendardText>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
          >
            <span
              style={{
                ...circleStyle,
                backgroundColor: "#34f3ff",
              }}
            />
            <PretendardText
              style={{
                fontWeight: 600,
                fontSize: "14px",
                lineHeight: "22.75px",
                color: "#aaa",
              }}
            >{`${payload[1].value.toLocaleString()}회`}</PretendardText>
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default HomeCustomTooltip;
